import { hideGlobalDialogErrorContext } from '@aionzdev/modules';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

/**
 * Acesso ao `/form-temp` do ebarn-node — armazenamento genérico de rascunho de
 * formulário por `usuario` + `chaveForm` (Mongo, upsert). Espelho do
 * `FormTempService` do `ebarn-frontend` (usado no carrinho de oferta
 * estruturada). Rota pública: identifica o usuário pelo path param, não pelo
 * token.
 *
 * O diálogo de erro global é desabilitado nas 3 chamadas: "não ter rascunho"
 * (404 em `getOne`) é o caminho normal na primeira vez que o usuário abre uma
 * tela, e `save`/`delete` são disparadas em background (debounce) sem
 * interação direta do usuário — nenhuma delas deve interromper a UI com um
 * diálogo de erro.
 */
@Injectable({ providedIn: 'root' })
export class FormTempApiService {
  private readonly _http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/form-temp`;

  /** `null` quando não há registro (404) — não é erro, é o caminho normal. */
  getOne<T>(usuario: string, chaveForm: string): Observable<T | null> {
    return this._http
      .get<{ dataForm: T }>(`${this.baseUrl}/${usuario}/${chaveForm}`, {
        context: hideGlobalDialogErrorContext,
      })
      .pipe(
        map(response => response?.dataForm ?? null),
        catchError(err => (err.status === 404 ? of(null) : throwError(() => err)))
      );
  }

  save(usuario: string, chaveForm: string, dataForm: unknown): Observable<void> {
    return this._http.post<void>(
      this.baseUrl,
      { usuario, chaveForm, dataForm },
      { context: hideGlobalDialogErrorContext }
    );
  }

  delete(usuario: string, chaveForm: string): Observable<void> {
    return this._http.delete<void>(`${this.baseUrl}/${usuario}/${chaveForm}`, {
      context: hideGlobalDialogErrorContext,
    });
  }
}
